<template>
  <amf-form :back-color="'#F8F8F8'" class="container">
    <div class="container" v-if="bankTransferId">
      <div class="row mt-3">
        <div class="col-6">
          <div class="col-12">
            <label><b>Employer</b></label>
            <span>{{ employerName }}</span>
          </div>
          <div class="col-12">
            <label><b>Created Date</b></label>
            <span>{{ $formatters.date(createdDate) }}</span>
          </div>
          <div class="col-12">
            <label><b>Gross Total Amount</b></label>
            <span>{{ $formatters.money(grossTotal) }}</span>
          </div>
          <div class="col-12" v-if="feeTotal">
            <label><b>Fee Total Amount</b></label>
            <span>{{ $formatters.money(feeTotal) }}</span>
          </div>
          <div class="col-12" v-if="netTotal">
            <label><b>Net Total Amount</b></label>
            <span>{{ $formatters.money(netTotal) }}</span>
          </div>
        </div>
        <div class="col-6">
          <div class="col-12">
            <label><b>Deposit Status</b></label>
            <span>
              <amf-select v-model="btStatus" :options="statuses" :columns="2"/>
            </span>
          </div>
        </div>
      </div>
    </div>
  </amf-form>
</template>

<script>
import { nachaLabels } from "./nacha-labels";

export default {
    data() {
        return {
            btStatus: null,
        };
    },
    props: {
        bankTransferId: { type: Number, required: true },
        employerName: { type: String, required: true},
        createdDate: { type: String, required: true },
        grossTotal: { type: String, required: true },
        feeTotal: { type: String, required: false },
        netTotal: { type: String, required: false },
        processingStatus: { type: Number, required: true},
        closeEditor: { type: Function }
    },
    computed: {
        footerButtons() {
            return "Save";
        },
        statuses() {
            return nachaLabels.hsaStatuses;
        }
    },
    methods: {
        async save() {
            await romeApi.post(`banktransfer/check-funded/status?bankTransferId=${this.bankTransferId}&processingStatus=${this.btStatus}`);
            toastService.success("Record updated");
            this.closeEditor(this.bankTransferId);
            await this.$store.dispatch("nachas/loadCheckFundedBankTransfers");
        },
        load() {
            this.btStatus = this.processingStatus;
        }
    },
    created() {
        this.load();
    },
    watch: {
        bankTransferId() {
            this.load();
        }
    }
};
</script>

<style lang="scss" scoped>
label {
  font-weight: 500;
}
label::after {
  content: ":";
}
</style>



// WEBPACK FOOTER //
// src/finance/CheckFundedDetail.vue